export default __webpack_public_path__ + "static/media/ios-battery-health-check.388aa602.png";